/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'omino-3': {
    width: 32,
    height: 54,
    viewBox: '0 0 32 54',
    data: '<g _stroke="#4A4A4A" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M6.268 32.674H3.007c-1.106 0-2.002-.917-2-2.045l.026-11.178c.009-3.082 2.488-5.598 5.511-5.588l13.043.033V7.822"/><path pid="1" d="M17.83 20.838v29.21c0 1.823-1.393 3.303-3.114 3.303H9.382c-1.72 0-3.115-1.48-3.115-3.303v-29.21M12.049 53.089V35.834M16.73 6.153c0 2.638-2.095 4.775-4.68 4.775-2.586 0-4.68-2.137-4.68-4.775 0-2.637 2.094-4.775 4.68-4.775 2.585 0 4.68 2.138 4.68 4.775zM22.117 7.033l-4.96-.092.05-2.822 4.961.092z"/><path pid="2" d="M27.798 7.993l-5.697-.107.082-4.529 5.697.108z"/><path pid="3" d="M31.073 9.204l-3.295-.062.122-6.827 3.295.062z"/></g>'
  }
})
